import type { FC } from "react";
import { memo } from "react";

import type { ButtonProps } from "@jti/core-components/components/Button";
import { Button } from "@jti/core-components/components/Button";
import { useTranslations } from "@jti/ui";

import styles from "./RemoveCartItemButton.module.scss";

type Props = {
  onClick(): void;
  size?: ButtonProps["size"];
};

export const RemoveCartItemButton: FC<Props> = memo(({ onClick, size }) => {
  const { __ } = useTranslations();

  return (
    <Button
      className={styles.button}
      size={size}
      variant="text"
      onClick={onClick}
      data-testid="cartRemoveButton"
      data-remove-button
    >
      {__("cart.cart_item.button.remove")}
    </Button>
  );
});
